import templateUrl from 'emun.filemanager/file-manager.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import $session from 'servicestack/session'
import uploadFilePrompt from 'emun.filemanager/upload-file-prompt'
import editFilePrompt from 'emun.filemanager/edit-file-prompt'
import folderPrompt from 'emun.filemanager/folder-prompt'
import resolve from 'ioc/resolve'
import ServiceBus from "servicestack/service-bus";
import modals from 'webmodals/modals'
import config from "emun.filemanager/file-manager.config";

class FileManagerController {
    constructor($scope) {
        const $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
        let $rootScope = resolve('$rootScope');
		$ctrl.$on('$documentUploaded', function () {
			$ctrl.foldersQuery.load(true);
		});
		$ctrl.$on('$folderCreated', function () {
			$ctrl.foldersQuery.load(true);
		});
		$scope.$watch(
			() => $ctrl.entityId,
			() => { 
				$ctrl.query.tagCriteria.Parent = $ctrl.entityId;
				$ctrl.query.load();
			}
		);
		$ctrl.documents = [];
		$ctrl.rootDocuments = [];
		$ctrl.rootFolders = [];
		$ctrl.views = {
			list: "th-list",
			cards: "th"
		};
			$ctrl.view = config.defaultView ? config.defaultView : "cards";

    }
    $onInit(){
		const $ctrl = this;
		var url = 'QueryMedia.json?Realm=' + $ctrl.realm;
      $ctrl.selectedFolder = {
        folderId: "/",
        documents: []
      };
		$ctrl.query = new AutoQuery({
			url: url,
			hideLeftNav: true,
			orderBy: '-Description',
			tagCriteria: {},
			criteria: {
				DescriptionContains: ''
			},
			autoLoad: false,
			onLoaded: function (args) {
				$ctrl.folders.forEach(function(folder) {
					folder.documents = [];
				});
				$ctrl.selectedFolder.documents = [];
				args.results.forEach(function (media) {
					var obj = $ctrl.folders.filter(function (obj) { return obj.folderId == media.tags["FolderId"]; });
					if (obj.length > 0) {
						if (($ctrl.$session.isRetailer() && $ctrl.$session.meta.PriceList && $ctrl.$session.meta.PriceList == media.tags["PriceList"]) || !$ctrl.$session.isRetailer() || !$ctrl.$session.meta.PriceList || !media.tags["PriceList"] || media.tags["PriceList"] == "") {
							obj[0].documents.push(media);
						}
					} else {
						if (($ctrl.$session.isRetailer() && $ctrl.$session.meta.PriceList && $ctrl.$session.meta.PriceList === media.tags["PriceList"]) || !$ctrl.$session.isRetailer() || !$ctrl.$session.meta.PriceList || !media.tags["PriceList"] || media.tags["PriceList"] == "") {
							$ctrl.selectedFolder.documents.push(media);
						}
					}
				});
			}
		});
		if ($ctrl.realm === "Documents" || $ctrl.realm === "User" || $ctrl.realm.indexOf("Vendor") > -1) $ctrl.query.pageSize=1000;
		else $ctrl.query.pageSize=12;

		if ($ctrl.$session.isRetailer()) {
			$ctrl.query.tagCriteria.Visibility = "Public";
		}
		if ($ctrl.entityId) {
			$ctrl.query.tagCriteria.Parent = $ctrl.entityId;
		}

		$ctrl.foldersQuery = new AutoQuery({
			url: 'QueryDocumentFolders.json',
			hideLeftNav: true,
			orderBy: 'FolderName',
			autoLoad: true,
			onLoaded: function (args) {
				$ctrl.documents = [];
				$ctrl.rootDocuments = [];
				$ctrl.rootFolders = [];
				$ctrl.folders = args.results;
				args.results.forEach(function (f) {
					if (!f.parentFolder || f.parentFolder === "/") {
						f.subFolders = [];
						$ctrl.rootFolders.push(f);
					}
				});
//				$ctrl.folders = args.results;
				$ctrl.folders.forEach(function (obj) {
					obj.documents = [];
					obj.subfolders = [];
					obj.isCollapsed = true;
					if (obj.parentFolder) {
						$ctrl.rootFolders.forEach(function (root) {
							if (root.folderId == obj.parentFolder) {
								obj.parentFolderName = root.folderName;
								root.subFolders.push(obj);
							}
						});
					}
					if ($ctrl.selectedFolder && $ctrl.selectedFolder.folderId === obj.folderId) $ctrl.selectFolder(obj);
				});
				//if ($ctrl.rootFolders.length === 1) { $ctrl.selectFolder($ctrl.rootFolders[0]); }
				$ctrl.query.load(true);
			},
			pageSize: 1000
		});

    }
    load(){
        const $ctrl = this;
        $ctrl.query.load(true);
    }
    view(report){
        const $ctrl = this;
        ReportPrompt.open({report: report}).then(() => $ctrl.load());
	}
	newFolder() {
		const $ctrl = this;
		var options = {
			parentFolder: $ctrl.selectedFolder.folderId || ""
		};
		folderPrompt.open(options).then(() => $ctrl.foldersQuery.load());
	}
	editFolder() {
		const $ctrl = this;
		var options = {
			folderId: $ctrl.selectedFolder.folderId,
			folderName: $ctrl.selectedFolder.folderName 
		};
		folderPrompt.open(options).then(() => $ctrl.foldersQuery.load());
	}
	uploadFile() {
		const $ctrl = this;
		var options = {
			realm: $ctrl.realm,
			folder: $ctrl.selectedFolder,
			folderId: $ctrl.selectedFolder.folderId || "",
			folderName: $ctrl.selectedFolder.folderName || "",
			entityId: $ctrl.entityId
		};
		uploadFilePrompt.open(options).then(() => $ctrl.query.load());
	}
	goRoot() {
		const $ctrl = this;
		$ctrl.selectedFolder = {
			folderId: "/",
			documents: []
		}
		$ctrl.query.load();
	}
	editDocument(doc) {
		const $ctrl = this;
		var options = {
			file: doc
		};
		editFilePrompt.open(options).then(() => $ctrl.query.load());
	}
	copyLink(doc) {
		const $ctrl = this;
		navigator.clipboard.writeText(doc.url);
	}
	deleteDocument(doc) {
		const $ctrl = this;
		return modals.confirm("Are you sure?", "Delete File").result.then(function () {
			$ctrl.bus.send('DeleteMedia.json', doc).then(function (response) {
				$ctrl.selectedFolder.documents = [];
				$ctrl.query.load();
			});
		});
	}
	selectFolder(folder) {
		let $ctrl = this;
		folder.isCollapsed = !folder.isCollapsed;
		$ctrl.selectedFolder = folder;
	}
	deleteFolder(folder) {
		let $ctrl = this;
		return modals.confirm("Are you sure?", "Delete Folder").result.then(function () {
			$ctrl.bus.send('DeleteDocumentFolder.json', folder).then(function (response) {
				$ctrl.foldersQuery.load(true);
				$ctrl.selectedFolder = {
					folderId: "/"
				}
			});
		});
	}
	openDocument(doc) {
		let $ctrl = this;
		window.open(doc.url, doc.label);
	}
}

export default FileManagerController;